import React from "react";
import styled from "styled-components/macro";
import { NavLink } from "react-router-dom";

import { spacing } from "@mui/system";

import {
  Box as MuiBox,
  Drawer as MuiDrawer,
  ListItemButton,
  Stack,
  Typography,
} from "@mui/material";

import { ReactComponent as Logo } from "../../vendor/logo.svg";
import Footer from "./SidebarFooter";
import SidebarNav from "./SidebarNav";
import { customColor } from "../../theme/variants";
import { imageDefaultStyleContain } from "../../theme/globalStyles";
import {
  APP_ADMIN_TITLE,
  APP_FULL_NAME,
  APP_NAME,
  APP_TITLE,
} from "../../utils/constant";

const Box = styled(MuiBox)(spacing);

const Drawer = styled(MuiDrawer)`
  border-right: 0;

  > div {
    border-right: 0;
  }
`;

const Brand = styled(ListItemButton)`
  font-size: ${(props) => props.theme.typography.h5.fontSize};
  font-weight: ${(props) => props.theme.typography.fontWeightMedium};
  color: ${(props) => props.theme.sidebar.header.color};
  background-color: ${(props) => props.theme.sidebar.header.background};
  font-family: ${(props) => props.theme.typography.fontFamily};
  min-height: 56px;
  padding-left: ${(props) => props.theme.spacing(6)};
  padding-right: ${(props) => props.theme.spacing(6)};
  justify-content: center;
  cursor: pointer;
  flex-grow: 0;

  ${(props) => props.theme.breakpoints.up("sm")} {
    min-height: 64px;
  }

  &:hover {
    background-color: ${(props) => props.theme.sidebar.header.background};
  }
`;

const BrandIcon = styled(Logo)`
  margin-right: ${(props) => props.theme.spacing(2)};
  color: ${(props) => props.theme.sidebar.header.brand.color};
  fill: ${(props) => props.theme.sidebar.header.brand.color};
  width: 32px;
  height: 32px;
`;

const Sidebar = ({ items, showFooter = true, ...rest }) => {
  return (
    <Drawer variant="permanent" {...rest}>
      <Brand
        component={NavLink}
        to="/"
        sx={{
          borderBottom: `1px solid ${customColor[50]}`,
        }}
      >
        <Stack
          direction="row"
          textAlign={"center"}
          gap={5}
          alignItems={"center"}
          sx={{ width: "100%" }}
        >
          <Box>
            <Box sx={{ height: "60px", width: "60px" }}>
              <img
                src="/static/img/hispanic-xl-logo.svg"
                alt="hispanic-logo"
                style={{ ...imageDefaultStyleContain }}
              />
            </Box>
          </Box>

          <Stack direction={"column"}>
            <Typography variant="h6">{APP_NAME}</Typography>
          </Stack>
        </Stack>
      </Brand>
      <SidebarNav items={items} />
      {!!showFooter && <Footer />}
    </Drawer>
  );
};

export default Sidebar;
